export const SSO_COOKIE_NAMES = ['gig_jwt', 'gig_uid', 'gig_lt', 'hy_at', 'hy_rt'] as const;

export type SsoCookieName = (typeof SSO_COOKIE_NAMES)[number];

/** TTL in minutes per cookie. */
export const SSO_COOKIE_CONFIG: Record<SsoCookieName, number> = {
    gig_jwt: 60,
    gig_uid: 60,
    gig_lt: 60,
    hy_at: 30,
    hy_rt: 60,
};

/** Minimum cookie TTL in ms (hy_at = 30 min), used for refresh scheduling. */
export const MIN_COOKIE_TTL_MS = 30 * 60 * 1000;
